import React from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

interface DraftsTableProps {
}

const DraftsTable: React.FC<DraftsTableProps> = () => {

    const inquiriesState = useAppSelector(state => state.inquiries);

    return (
        <table className="data">
            <thead>
            <tr>
                <th>Klient</th>
                <th>Vedaja</th>
                <th>Teenuse liik</th>
                <th>Marsruut</th>
                <th className="right w150"></th>
            </tr>
            </thead>
            <tbody>
            {inquiriesState.drafts.map(row => (
                <React.Fragment key={row.id}>
                    {typeof row.parent === 'object' && row.parent !== null &&
                    <tr key={`parent-${row.id}`} style={{opacity: 0.7}}>
                        <td style={{paddingLeft: 20}}>
                            <Link to={`/clients/${row.parent.client?.id}/modify`}>{row.parent.client?.name}</Link>
                        </td>
                        <td style={{paddingLeft: 20}}>
                            <Link to={`/vendors/${row.parent.vendor?.id}/modify`}>{row.parent.vendor?.name}</Link>
                        </td>
                        <td style={{paddingLeft: 20}}>{row.parent.service?.name}</td>
                        <td style={{paddingLeft: 20}}>{row.parent.loading_cities} → {row.parent.unloading_cities}</td>
                        <td></td>
                    </tr>}
                    <tr>
                        <td>
                            <Link to={`/clients/${row.client?.id}/modify`}>{row.client?.name}</Link>
                        </td>
                        <td>
                            <Link to={`/vendors/${row.vendor?.id}/modify`}>{row.vendor?.name}</Link>
                        </td>
                        <td>{row.service?.name}</td>
                        <td>{row.loading_cities} → {row.unloading_cities}</td>
                        <td className="action">
                            <Link to={`/orders/${row.id}/modify`} style={{marginLeft: 3, marginRight: 3}}>Muuda</Link>
                            <span>|</span>
                            <Link to={`/orders/${row.id}/delete`} style={{marginLeft: 3, marginRight: 3}}>🗑️</Link>
                        </td>
                    </tr>
                </React.Fragment>
            ))}
            </tbody>
        </table>
    );
}
export default DraftsTable;